import _ from 'lodash'
import Client from "data/_client"


const dispatch = (detail={}) => document.dispatchEvent(new CustomEvent('rdcf-object-in-use', {detail}))

type Options = {
  deleteFn?: Function
  refreshFn: Function
  canForce?: boolean
  special?: string
  specialId?: any
  key?: string
}

export async function handleReferences(table: string, id: number|number[], options: Options): Promise<boolean> {
  const {deleteFn, refreshFn, canForce, special, specialId} = options
  const isDelete = !!deleteFn

  const isDepartmentalReference = (references) => {
    if(references && references.length === 1 && _.get(references, "[0].referencedBy.type") === "hosp_dept_expense") return true
    else return false
  }

  if (Array.isArray(id)) {
    let refs = await Promise.all(_.map(id, id => Client.get(`in-use/${table}/${id}`)))
    let codes = _.map(refs, ref => _.get(ref, 'object.suite') ? _.get(ref, 'object.suite') : _.get(ref, 'object.code'))

    let codes_with_ids = new Map()
    codes.forEach((code, index) => {codes_with_ids.set(code, id[index])})

    let removable_refs = _.remove(refs, r => !r.references.length)
    let removable_ids = removable_refs.map(ref => codes_with_ids.get(_.get(ref, 'object.suite') ? _.get(ref, 'object.suite') : _.get(ref, 'object.code')))

    let num_removable = removable_ids.length
    let num_not_removable = refs.length

    if(refs.length && isDelete) {
      dispatch({
        message: [num_removable == 0 ? 'All objects are in use and cannot be deleted.':
            'Some objects are in use and cannot be deleted.'],
        no_delete: _.map(refs, r => getNameCode(r.object)),
        can_delete: removable_ids,
        deleteFn: deleteFn,
        num_removable: num_removable,
        num_not_removable: num_not_removable
      })
      return false
    }
    return true
  }

  let url = `in-use/${table}/${id}`
  if (special) {
    url += `/${special}/${specialId}`
  }

  const res = await Client.get(url)
  if (_.isEmpty(res.references) || isDepartmentalReference(res.references)) {
    if(!isDelete) {
      dispatch()  // empty for "no references found" dialog when used as trace (not pre-delete check)
    }
    return true // so caller can proceed with delete
  }

  const { name, code } = getNameCode(res.object)

  const alternatives = _.some(res.alternatives, it => it.sortorder)
    ? _.map(_.filter(_.sortBy(res.alternatives, ["sortorder", "code", "suite"]), it => it.sortorder !== null && it.parentrentrollid === null), getNameCode)
    : _.map(_.sortBy(res.alternatives, ["sortorder", "code", "suite"]), getNameCode)

  dispatch({
    alternatives,
    deleteFn,
    object: {table, name, code, [`${table}id`]: id},
    references: res.references,
    refreshFn,
    noReplace: res.noReplace,
    canForce,
    special,
    specialId,
    num_removable: 0,
    num_not_removable: 1
  })
  return false // so caller can abort delete and delegate to replace/delete dialog via deleteFn

  function getNameCode(datum) {
    let name, code;
    const id = datum[`${table}id`]
    if (table == 'rentroll') {
      name = datum.tenant
      code = datum.suite
    } else if (table == 'multifamily') {
      name = ''
      code = datum.unitdescription
    } else if (['summaryaccount', 'detailaccount'].includes(table)) {
      name = datum.description
      code = datum.accountnumber
    } else {
      name = datum.name
      code = datum.code
    }
    return {name, code, id, table}
  }
}

export async function replace(table, targetid, replacement, special?, specialId?) {
  let url = `in-use/${table}/${targetid}`
  if (special) {
    url += `/${special}/${specialId}`
  }

  const res = await Client.patch(url, {replacement})
  if (res.errors) return Promise.reject(res.errors[0])
  return res.changes
}
